@if (isLoading() && !device()) {
  <div id="loading-spinner">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else if (getDeviceError()) {
  <app-error-page [primaryText]="getDeviceError()!.message"></app-error-page>
} @else if (device()) {
  <div id="title--container">
    <h4>Device {{ deviceId }}</h4>
    <h5>{{ laboratory?.laboratoryName }}</h5>
  </div>
  <hr />
  <div id="inner-page--container">
    <div id="toggle--container">
      <app-underlined-option-tab-toggle
        radioGroup="navigationToggle"
        [selectOptions]="navOptions"
      >
      </app-underlined-option-tab-toggle>
    </div>
    <hr />
    <div id="device-details--container">
      <div id="header">
        <div id="device-details-title">
          <h6>Device Overview:</h6>
          @if (device()?.softwareWarning === true) {
            <div class="body1 software-status">
              <app-software-status-icon [softwareWarning]="true" />
              A
              <a
                href="https://ogibiotec.com/resources/"
                target="_blank"
                class="body1"
              >
                software update</a
              >
              is available
            </div>
          } @else if (device()?.softwareWarning === false) {
            <div class="body1 software-status">
              <app-software-status-icon [softwareWarning]="false" />
              The device software is up to date
            </div>
          } @else {
            <div class="body1 software-status">
              <app-software-status-icon [softwareWarning]="null" />
              Software status unavailable
            </div>
          }
        </div>
        @if (
          device() &&
          !device()!.isDeleted &&
          currentUser.role === Role.OGI_Super_Administrator
        ) {
          <app-icon-button
            label="delete device"
            buttonId="delete-device-btn"
            buttonShape="square"
            buttonStyle="negative"
            iconName="delete"
            (buttonClicked)="openModal('delete-device')"
            [isDisabled]="
              isProcessing ||
              device()!.deviceStatusId !== DeviceSetupStatus.Inactive ||
              !(currentUser.role | roleCheck: ogiSuperAdminOnly)
            "
            [isProcessing]="isProcessing"
          ></app-icon-button>
        }
      </div>
      <div id="card-container">
        @if (device() && device()?.deviceModules) {
          <app-device-card [device]="device()!"></app-device-card>
          <app-installed-modules-card
            [activeModules]="device()?.deviceModules"
          ></app-installed-modules-card>
        }
      </div>
    </div>
    <hr />
    <div id="update-device--container">
      <form [formGroup]="deviceForm" (ngSubmit)="updateDevice()">
        <div class="section--container">
          <h6>Edit Device</h6>
          <div class="field-row">
            <app-underlined-form-field
              [parentForm]="deviceForm"
              [field]="nameField"
            ></app-underlined-form-field>
            @if (hasLCModule()) {
              <app-number-form-field
                [parentForm]="deviceForm"
                [field]="pumpTubeLengthField"
                [minValue]="minPumpTubeLength"
                [maxValue]="maxPumpTubeLength"
                [step]="pumpTubeLengthStep"
                tooltipText="Default tubing provided with the system is 85 cm."
              ></app-number-form-field>
            }
          </div>
          <div class="button--container">
            @if (!device()?.isDeleted) {
              <app-button
                label="update device"
                buttonId="update-device-btn"
                buttonShape="square"
                buttonType="submit"
                [isDisabled]="
                  isUpdateButtonDisabled() ||
                  !(currentUser.role | roleCheck: labAdminRoles)
                "
                [isProcessing]="isProcessing"
              ></app-button>
            }
            @if (device()?.deviceStatusId !== 3) {
              <span class="body1">
                Note: Device cannot be updated when in use
              </span>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-error-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="update-device"
  titleText="Success"
  [primaryText]="updateDeviceSuccessMessage"
  primaryButtonText="close"
  primaryButtonId="close-success-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-device"
  titleText="Delete device?"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="confirm-delete-button"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-delete-button"
  (modalButtonClicked)="deleteDevice()"
  [error]="error"
></app-validation-modal>
